import type { Resource } from '../../';
export const country_countries_NL: Resource = {"default":"Netherlands"};
